<template>
  <div class="flex flex-wrap justify-center">
    <div class="max-w-xl min-w-full sm:min-w-30 m-2">
      <div class="bg-white rounded-lg shadow-card p-8 sm:p-12">
        <h1 class="mb-3 font-semibold text-2xl lg:text-3xl text-center">
          Don’t Lose Your Work!
        </h1>
        <p class="text-center my-10">
          Before you move forward Name Your Event, Create an Account and Save Your Work.
          <br /><br />
          We’ll keep it safe and sound for you. There’s no charge, no credit card needed. Just save it!
        </p>
        <fieldset class="mt-5">
          <label for="event" class="font-semibold text-center block">
            What are you going to call this Event?
          </label>
          <input type="text" class="input mt-2" id="event" placeholder="Event Name..." v-model="event" />
        </fieldset>
        <div class="flex justify-center flex-col-reverse sm:flex-row mt-10">
          <button
            class="btn btn-primary font-semibold rounded px-10 w-full sm:w-48 sm:flex-none mr-0 sm:mr-4 mt-3 sm:mt-0"
            @click="saveAndContinue"
            :disabled="!isAuthenticated || !event.trim()"
          >
            <span v-if="!loadingSave">Save & Exit</span>
            <Spinner class="mx-auto" v-if="loadingSave" />
          </button>
          <button
            class="btn btn-secondary font-semibold rounded px-10 w-full sm:w-auto sm:flex-none"
            @click="$emit('exit')"
          >
            Exit
          </button>
        </div>
      </div>
    </div>
    <div v-if="!isAuthenticated" class="max-w-xl min-w-full sm:min-w-30 m-2">
      <transition name="flip" mode="out-in">
        <div v-if="authMethod === 'login'" :key="'login'">
          <SignIn @forgot="authMethod = 'forgot'">
          <span slot="header-title">
            Save Your Work!
          </span>
            <span slot="button-title">
            Login & Continue
          </span>
            <div slot="footer" class="text-center mt-10 mb-5">
              <a href="javascript:" class="text-primary" @click="authMethod = 'signup'">
                Don't have account? SignUp!!!
              </a>
            </div>
          </SignIn>
        </div>
        <div v-if="authMethod === 'signup'" :key="'signup'">
          <SignUp>
          <span slot="header-title">
            Save Your Work!
          </span>
            <span slot="button-title">
            Sign Up & Save Your Work - It’s FREE
          </span>
            <div slot="footer" class="text-center mt-10 mb-5">
              <a href="javascript:" class="text-primary" @click="authMethod = 'login'">
                I already have account!!!
              </a>
            </div>
          </SignUp>
        </div>
        <div v-if="authMethod === 'forgot'" :key="'forgot'">
          <ForgotPassword @success="authMethod = 'login'" />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import SignIn from "@/components/common/auth/SignIn"
  import SignUp from "@/components/common/auth/SignUp"
  import ForgotPassword from "@/components/common/auth/ForgotPassword"
  import {mapGetters} from "vuex"
  import Spinner from "@/components/common/Spinner"
  import Api from "@/api"

  export default {
    components: {
      Spinner,
      ForgotPassword,
      SignUp,
      SignIn
    },
    data() {
      return {
        authMethod: 'login',
        loadingSave: false,
        event: ''
      }
    },
    computed: {
      ...mapGetters({
        isAuthenticated: 'isAuthenticated',
        authUser: 'personalDetails'
      })
    },
    methods: {
      saveAndContinue() {
        this.loadingSave = true
        Api.updateOrderWith(this.$store.state.segmentationOrder.uuid, {
          name: this.event
        }).then(async () => {
          try {
            await Api.addOwnerToOrder(
              this.$store.state.segmentationOrder.uuid,
              this.$store.state.auth.user.id
            )
            this.loadingSave = false
            this.$emit('exit')
          } catch {
            this.loadingSave = false
          }
        }).catch(() => {
          this.loadingSave = false
        })
      }
    }
  }
</script>